import React from 'react';
import classnames from 'classnames';
import Tooltip from 'react-tooltip';
import Thumbnail from 'common/components/thumbnail';
import moment from 'moment';

const Revisions = ({ entry, currentRevision, onRevisionChange }) => {
  if (entry.revisions.length < 2) {
    return null;
  }

  return (
    <div className="entry-revisions">
      <h5>All<br/> Versions:</h5>
      <ul>
        { entry.revisions.map((revision, idx) => (
        <li key={idx} className="revision">
          <Thumbnail
            onClick={() => { onRevisionChange(revision.id); }}
            className={classnames('tile thumbnail flex actionable', {
              selected: (revision.id === currentRevision) || (!currentRevision && idx === 0),
            })}
            image={revision.thumbnails[0]}
            dataTip={true}
            dataFor={`tooltip-${revision.id}`}
          />
          <Tooltip class="tooltip" effect="solid" place="top"
              id={`tooltip-${revision.id}`}>
            Added { moment(revision.created_at).fromNow() }
            { idx === 0 && ' (most recent)' }
          </Tooltip>
        </li>
        )) }
      </ul>
    </div>
  );
}

export default Revisions;



// WEBPACK FOOTER //
// ./project/components/entry_details/revisions.jsx